<div class="row">
  <dt class="col-2">{{ languageDisplay }}</dt>
  <dd class="col-7">{{ xliff[language['key']] }}</dd>
</div>
